const TAG_BLUE = '#005298'
const TAG_RED = '#FF5F5F'
const TAG_MAIN_BACKGROUND = '#F5F8FC'
const TAG_BORDER_BLUE = '#A4C8E9'
const TAG_LIGHT_BLUE = '#EAF5FF'
const TAG_LIGHT_RED = '#FFE7E7'
const TAG_LIGHT_PURPLE = '#FCF0FF'
const TAG_GRAY_FILL = '#F6F6F6'
const TAG_LINES_GRAY = '#CACACA'
const TAG_TEXT_GRAY = '#959595'
const TAG_PURPLE = '#7A0098'
const WHITE = '#fff'
const BLACK = '#000'
const GREEN = '#29CC6A'
const TAG_PURPLE_BOX_FILL = '#FCF0FF'
const TAG_SECONDARY_BLUE = '#5A9AD0'

export default {
  TAG_BLUE,
  TAG_RED,
  TAG_MAIN_BACKGROUND,
  TAG_BORDER_BLUE,
  TAG_LIGHT_BLUE,
  TAG_LIGHT_RED,
  TAG_LIGHT_PURPLE,
  TAG_GRAY_FILL,
  TAG_LINES_GRAY,
  TAG_TEXT_GRAY,
  TAG_PURPLE,
  WHITE,
  BLACK,
  GREEN,
  TAG_PURPLE_BOX_FILL,
  TAG_SECONDARY_BLUE,
}
